








import { Component, Prop, Provide, Vue, Emit } from "vue-property-decorator";
import CommonHeader from "./components/common/common_header/common_header.vue";
import CommonFooter from "./components/common/common_footer/common_footer.vue";

@Component({//Component组件装饰器，用于增加一些全局的配置
 components:{//components里面放一些全局的组件，引入子组件后写在这，跟vue中的components一样
  CommonHeader,
  CommonFooter
 }
})
export default class App extends Vue {
  //  @Provide() private name: string = 'weipingping'; //定制属性，替换data，正常情况下直接使用
    //private   修饰的属性或者方法是私有的，只在此类中有效
    //public    修饰的属性或者方法是公有的，任何组件都可以访问到
    //protected 修饰的属性或者方法是私有的，但它的子组件可以访问到

    //Emit 给父组件传值
    //方式一
    // private add(): void{
    //   @Emit("add","传递的参数")
    // }
    // //方式二
    // @Emit ("add","传递的参数")
    // private add(): void{
    //   console.log("这个方法运行完成后触发Emit")
    // }

    //@Prop接收父组件传递的数据（）里面定义接收的类型
    // @Prop(Object) private list!: any;//！表示这个值必须传，不然报错，强制性。

    // @Watch监听属性
    // @Model接收父组件双向数据绑定的数据
    // @Inject注入 正常情况下使用Provide



//页面载入动画效果 需要加载的模块增加样式class animate
// .animate{
//     opacity: 0;
//     transition: 0.2s all;
//     transform: scale(0.8);
// }
    // public fadeInElements:any = [];
    // mounted(){
    //     // 先获取全部需要过渡效果的元素
    //     this.fadeInElements = Array.from(document.getElementsByClassName('results'))
    //     // 监听鼠标滚动事件 
    //     document.addEventListener('scroll', this.handleScroll)
    // }
    // 循环判断是否要触发过渡
    // handleScroll (evt:any) {
    //   for (var i = 0; i < this.fadeInElements.length; i++) {
    //     var elem = this.fadeInElements[i]
    //     if (this.isElemVisible(elem)) {
        //   elem.style.opacity = '1'
        //   elem.style.transform = 'scale(1)'
        //   this.fadeInElements.splice(i, 1) // 只让它运行一次
    //     }
    //   }
    // }
    // // 判断元素距离窗口的位置
    // isElemVisible (el:any) {
    //   var rect = el.getBoundingClientRect()
    //   var elemTop = rect.top + 250 // 200 = buffer
    //   var elemBottom = rect.bottom
    //   return elemTop < window.innerHeight && elemBottom >= 0
    // }
}

